import {createAction, props} from '@ngrx/store';
import {BelegAktualisierungenDTO} from '../../openapi/fakturierung-openapi';


export class BelegAktualisierungenActions {

  public static loadBelegAktualisierungen = createAction(
    '[BelegAktualisierungen] Load beleg aktualisierungen',
    props<{betriebId: string; belegId: string}>(),
  );

  public static loadBelegAktualisierungenSuccess = createAction(
    '[BelegAktualisierungen] Load beleg aktualisierungen success',
    props<{belegId: string; aktualisierungen: BelegAktualisierungenDTO}>(),
  );

  public static loadBelegAktualisierungenFailure = createAction(
    '[BelegAktualisierungen] Load beleg aktualisierungen failure',
    props<{belegId: string; error: unknown}>(),
  );
}
